import React, { useEffect } from 'react';
import useGlobal from '../../store';

const KeyElementWidget = (props) => {

    const [ui, uiActions] = useGlobal(
        state => state.ui.dashboard,
        actions => actions.uiActions
    );
    useEffect(() => {

    }, [ui]);

    const openSidePanelView = () => {
        uiActions.toggleSidePanel(props.viewpanel);
    }

    const openSidePanelAdd = () => {
        uiActions.toggleSidePanel(props.addpanel);
    }

    const colorClass = props.color ? props.color : "success";
    return (
        <div className="kt-portlet kt-portlet--height-fluid kt-widget-12">
            <div className="kt-portlet__body">
                <div className="kt-widget-12__body">
                    <div className="kt-widget-12__head">
                        <div className={"kt-widget-12__date kt-widget-12__date--"+colorClass}>
                            <span className="kt-widget-12__day">{props.number}</span>
                            
                        </div>
                        <div className="kt-widget-12__label">
                            <h3 className="kt-widget-12__title">{props.title}</h3>
                            <span className="kt-widget-12__desc">{props.subtitle}</span>
                        </div>
                    </div>
                    <div className="kt-widget-12__info">
                        {props.description}
                    </div>
                </div>
            </div>
            <div className="kt-portlet__foot kt-portlet__foot--md">
                <div className="kt-portlet__foot-wrapper" style={{display:"flex", flexWrap:"nowrap"}}>
                    {props.viewpanel ? <button onClick={() => openSidePanelView()} className="btn btn-block btn-info btn-sm btn-bold btn-wide btn-upper mr-2">
                        View
                    </button> : <></> }
                    {props.addpanel ? <button onClick={() => openSidePanelAdd()} className="btn btn-block btn-success btn-sm btn-wide btn-bold btn-upper m-0">
                        Add
                    </button> : <></> }
                </div>
            </div>
        </div>
    );
}

export default KeyElementWidget;